import React from 'react';

import './ContactInfo.scss';

const ContactInfo = () => (
  <div className="contact-info">
    <div className="contact-info__title">
      We&apos;re available
    </div>
    <div className="contact-info__subtitle">
      24 / 7 / 365
    </div>
    <div className="contact-info__text">
      For more information, please submit the form below and a representative
      from Process General will respond upon receipt.
    </div>
  </div>
);

export default ContactInfo;



// WEBPACK FOOTER //
// ./src/routes/Contact/components/ContactInfo/ContactInfo.js